import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useEffect, useMemo, useState } from "react";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend
);

interface Last7DaysResponse {
  dates: string[];
  gold_sell_hkd: (number | null)[];
}

export function PriceChart() {
  const [payload, setPayload] = useState<Last7DaysResponse | null>(null);
  const [loading, setLoading] = useState(true);

  const load = async (activeRef: { active: boolean }) => {
    if (activeRef.active) setLoading(true);
    try {
      const res = await fetch("/api/prices/last7days", { cache: "no-store" });
      if (!res.ok) throw new Error("failed");
      const json = (await res.json()) as Last7DaysResponse;
      if (activeRef.active) setPayload(json);
    } catch {
      if (activeRef.active) setPayload(null);
    } finally {
      if (activeRef.active) setLoading(false);
    }
  };

  useEffect(() => {
    const activeRef = { active: true };
    void load(activeRef);

    const onRefresh = () => void load(activeRef);
    window.addEventListener("skt:refresh-data", onRefresh);
    return () => {
      activeRef.active = false;
      window.removeEventListener("skt:refresh-data", onRefresh);
    };
  }, []);

  const chartData = useMemo(() => {
    const labels = payload?.dates ?? [];
    const data = payload?.gold_sell_hkd ?? [];
    return {
      labels,
      datasets: [
        {
          label: "黃金賣出（HKD）",
          data,
          borderColor: "#facc6b",
          backgroundColor: "rgba(250, 204, 107, 0.25)",
          tension: 0.3,
          fill: true,
          pointRadius: 3,
          spanGaps: true
        }
      ]
    };
  }, [payload]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    },
    scales: {
      x: {
        ticks: {
          color: "#e5e7eb"
        }
      },
      y: {
        ticks: {
          color: "#e5e7eb"
        }
      }
    }
  };

  return (
    <div className="chart-container">
      {loading && <div>載入中…</div>}
      {!loading && !payload && <div>暫時未有足夠數據。</div>}
      {payload && <Line data={chartData} options={options} />}
    </div>
  );
}

